import {IUsageLoggingService} from "./IUsageLoggingService";


export function setupLogPageChange(usageLoggingService: IUsageLoggingService) {
    let beaconHasBeenSent = false;
    let params: URLSearchParams;
    const userLeavesPage = () => {
        if (beaconHasBeenSent || !navigator || !navigator.sendBeacon) {
            return;
        }

        beaconHasBeenSent = navigator.sendBeacon(
            '/usage/log',
            params || new URLSearchParams([
                ['application',  usageLoggingService.application],
                ['action',  'PAGE_CHANGE'],
                ['layers',  ''],
                ['spatial_extent',  `from "${window.location.pathname}"`],
            ])
        );
    }

    function logAnchorClick (anchor: Element) {
        if (anchor instanceof HTMLElement) {
            params = new URLSearchParams([
                ['application', usageLoggingService.application],
                ['action', 'CLICK_LINK'],
                ['layers', ''],
                ['spatial_extent', `from "${window.location.pathname}" to "${anchor.getAttribute('href')}"`],
                ['session_uuid', usageLoggingService.getSessionUuid()],
                ['ip', usageLoggingService.ip],
            ]);
        }
    }

    document.querySelectorAll('a[href]')
        .forEach(anchor => {
            anchor.addEventListener('click', () => logAnchorClick(anchor));
        });

    const terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';

    document.addEventListener(terminationEvent, function (ev) {
        userLeavesPage();
    });

    document.addEventListener('visibilitychange', function (ev) {
        if (document.visibilityState === 'hidden') {
            userLeavesPage();
        }
    });
}